<template>
    <div>
        <link rel="stylesheet" href="/themes/ito/css/upgrade-feature.css">
        <div class="d-flex d-flex-space-between">
            <div class="label">
                <span>{{ $t("package_selected") }} : </span>
                <strong>{{ showInfo('name') }}</strong>
            </div>
            <div class="fw-bold">{{ showInfo('price') }}</div>
        </div>
        <!-- <p class="label-upgrade">{{$t('lisa_web_add_a_promotion_code')}}</p>
        <div class="d-flex align-items-center" style="margin-bottom: 12px">
            <input class="input-promotion" style="width:83%" :placeholder="$t('enter_the_promotion_code')" v-model="applyCode"/>
            <div class="btn-promotion-code btn-apply_code btn" style="width:17%" :style="applyCode != '' ? 'background: #00A3FF;':''">{{$t('apply_code')}}</div>
        </div> -->
        <p class="label-upgrade">{{ $t('please_select_how_you_would_like_to_pay') }}</p>
        <div class="d-flex slect-method">
            <template v-for="(gate, index) in gates">
                <input :id="'method_' + index" name="radio-select" type="radio" v-model="method" :value="gate.method" />
                <label :for="'method_' + index" class="payment-method-item box-shadow-main">
                    <div class="img-gate-box">
                        <img :src="gate.icon">
                    </div>
                    <div class="payment-method-text" v-html="gate.name"></div>
                </label>
            </template>
        </div>
        <div class="col-md-12 mt-20 text-center">
            <div class="btn btn-back" @click="updateStep(2)"> {{ $t('back') }}</div>
            <div class=" btn btn-main" :class="{ 'disabled': method === '' }" @click="method != '' ? updateStep(4) : ''" :aria-disabled="method === ''">{{ $t('pay_now') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpgradeFeaturePayment',
    props: {
        package_select: {
            type: String,
            required: true
        },
        showInfo: {
            type: Function,
            required: true
        },
        gates: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            method: '',
            applyCode: '',
        }
    },
    methods: {
        updateStep(step) {
            this.$emit('updateStep', step, '', this.method, this.applyCode);
        }
    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.slect-method [type="radio"]+label:before,
.slect-method [type="radio"]+label:after {
    display: none;
}

.slect-method [type=radio]:checked+label.payment-method-item {
    opacity: 1;
    border: 2px solid #40C0F6;
}

.slect-method label {
    display: block;
}

.payment-method-item {
    display: flex;
    min-height: 180px;
    padding: 12px;
}

.img-gate-box {
    padding: 20px 25px 10px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.img-gate-box img {
    width: 100%;
    height: 140px !important;
    object-fit: contain;
}

.payment-method-text {
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin-top: 0;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: start;
}

.d-flex-space-between {
    justify-content: space-between;
    margin-bottom: 15px;
}

.btn-payment-change {
    margin: 30px 5px;
}

.btn-undo {
    background: #fff;
    color: #212529;
    width: 120px;
}

.btn-back{
    font-size: 20px;
    height: 45px;
    margin-right: 20px;
    line-height: 45px;
    align-items: center;
    width: fit-content;
    line-height: 32px;
}

.btn-main.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}

.btn-apply_code {
    color: #FFFFFF;
    text-align: center;
    font-weight: 700;
    padding: 9px;
    height: 44px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #A3A3A3;
    border-radius: 8px;
}
</style>